<template>  
  <div class="home-container">
    <!-- banner图 -->
    <!-- <img :src="banner" alt="" /> -->
    <!-- 服务台和CDS入口，搜索区域 -->
    <!-- <input-out></input-out> -->
    <!-- 信息区域 -->

    <div class="infos">
      <!-- 左侧，通知公告 -->
      <div class="info-item">
        <div style="padding-bottom: 35px">
          <my-title :title="'通知公告'" @handleMoreClick="toTab(2)"></my-title>
        </div>
        <template v-if="info1.length">
          <div v-for="(item, index) of info1" :key="'info-item-' + index">
            <!-- 首个信息，单独处理样式 -->
            <template v-if="index == 0">
              <p class="first-title" @click="Tab1Details(item)">
                {{ item.title }}
              </p>
              <!-- <p class="first-msg">{{ item.detail }}</p> -->
              <v-clamp
                autoresize
                :max-lines="6"
                class="first-msg"
                :clampTxt="item.contentForSearch"
              />
            </template>
            <!-- 其余信息，使用一种样式 -->
            <template v-else>
              <div class="other-item">
                <p class="other-title" @click="Tab1Details(item)">
                  {{ item.title }}
                </p>
                <v-clamp
                  autoresize
                  :max-lines="2"
                  class="other-msg"
                  :clampTxt="item.contentForSearch"
                  :coverColor="'#f7f7f7'"
                />
              </div>
            </template>
          </div>
        </template>
        <template v-else>
          <none-icon />
        </template>
      </div>
      <!-- 中间：业务指南，常见问题 -->
      <div class="info-item info-item-center">
        <!-- 中间的一半区域 -->
        <div class="info-item-harf-top">
          <div style="padding-bottom: 35px">
            <my-title
              :title="'业务指南'"
              @handleMoreClick="toTab(3)"
            ></my-title>
          </div>
          <template v-if="info2.length">
            <div v-for="(item, index) of info2" :key="'info-item-' + index">
              <!-- 首个信息，单独处理样式 -->
              <template v-if="index == 0">
                <p class="first-title" @click="Tab2Details(item)">
                  {{ item.title }}
                </p>
                <!-- <p class="first-msg">{{ item.detail }}</p> -->
                <!-- <v-clamp autoresize :max-lines="6" class="first-msg">{{ item.detail }}</v-clamp> -->
              </template>
              <!-- 其余信息，使用一种样式 -->
              <template v-else>
                <p class="first-title-small" @click="Tab2Details(item)">
                  {{ item.title }}
                </p>
              </template>
            </div>
          </template>
          <template v-else><none-icon /></template>
        </div>
        <!-- 中间的一半区域 -->
        <div class="info-item-harf-bottom">
          <div style="padding-bottom: 35px">
            <my-title
              :title="'常见问题 '"
              @handleMoreClick="toTab(6)"
            ></my-title>
          </div>
          <template v-if="info3.length">
            <div v-for="(item, index) of info3" :key="'info-item-' + index">
              <!-- 首个信息，单独处理样式 -->
              <template v-if="index == 0">
                <p class="first-title" @click="Tab3Details(item)">
                  {{ item.title }}
                </p>
                <!-- <p class="first-msg">{{ item.detail }}</p> -->
                <!-- <v-clamp autoresize :max-lines="6" class="first-msg">{{ item.detail }}</v-clamp> -->
              </template>
              <!-- 其余信息，使用一种样式 -->
              <template v-else>
                <p class="first-title-small" @click="Tab3Details(item)">
                  {{ item.title }}
                </p>
              </template>
            </div>
          </template>
          <template v-else><none-icon /></template>
        </div>
      </div>
      <!-- 右侧：行业资讯，资料下载 -->
      <div class="info-item info-item-left">
        <!-- 中间的一半区域 -->
        <div class="info-item-harf-top">
          <div style="padding-bottom: 35px">
            <my-title
              :title="'行业资讯'"
              @handleMoreClick="toTab(1)"
            ></my-title>
          </div>
          <template v-if="info4.length">
            <div v-for="(item, index) of info4" :key="'info-item-' + index">
              <!-- 首个信息，单独处理样式 -->
              <template v-if="index == 0">
                <p class="first-title" @click="Tab4Details(item)">
                  {{ item.title }}
                </p>
                <!-- <p class="first-msg">{{ item.detail }}</p> -->
                <!-- <v-clamp autoresize :max-lines="6" class="first-msg">{{ item.detail }}</v-clamp> -->
              </template>
              <!-- 其余信息，使用一种样式 -->
              <template v-else>
                <p class="first-title-small" @click="Tab4Details(item)">
                  {{ item.title }}
                </p>
              </template>
            </div>
          </template>
          <template v-else><none-icon></none-icon></template>
        </div>
        <!-- 中间的一半区域 -->
        <div class="info-item-harf-bottom">
          <div class="head">资料下载</div>
          <template v-if="info5.length">
            <div class="down-list">
              <div
                class="list-item"
                v-for="(item, index) of info5"
                :key="'info-item-' + index"
                @click="downFile(item)"
              >
                {{ item.title }}
              </div>
              <p @click="toTab(5)">查看更多&nbsp;&nbsp;&nbsp;></p>
            </div>
          </template>
          <template v-else><none-icon /></template>
        </div>
      </div>
    </div>
    <!-- 产品中心 -->
    <div style="width: 1270px; margin: 0 auto 120px">
      <my-title
        style="padding: 40px 0"
        :title="'产品中心'"
        @handleMoreClick="toTab(4)"
      ></my-title>
      <div class="products">
        <div
          class="pro-item"
          v-for="(item, index) of products"
          :key="'pro-item-' + index"
          :pro-item-index="index"
          @click="productCentertoTab(item)"
        >
          <img :src="item.url" />
          <p class="title">{{ item.title }}</p>
          <p class="detail">{{ item.detail }}</p>
        </div>
      </div>
    </div>
    <showPDF ref="showPDF" />
  </div>
</template>

<script>
import axios from "axios";
import banner from "@/assets/banner.png";
// import InputOut from './InputOut.vue'
import MyTitle from "./MyTitle.vue";
// import VClamp from 'vue-clamp'
// 导入产品中心，icon
import icon01 from "../../assets/icon01.png";
import icon02 from "../../assets/icon02.png";
import icon06 from "../../assets/icon06.png";
import icon04 from "../../assets/icon04.png";
import icon05 from "../../assets/icon05.png";
import icon07 from "../../assets/icon07.png";
import showPDF from "./showPDF.vue";
export default {
  name: "HomePage",
  components: {
    showPDF,
    MyTitle,
    // VClamp
  },
  data() {
    return {
      pages: { total: 0, current: 1, size: 10 },
      secondMenuList: [
        {
          value: "1",
          label: "授信服务 ",
        },
        {
          value: "2",
          label: "数据产品 ",
        },
        {
          value: "3",
          label: "报表产品 ",
        },
        {
          value: "4",
          label: "培训产品 ",
        },
        {
          value: "5",
          label: "金融服务",
        },
        {
          value: "6",
          label: "增值服务",
        },
      ],
      banner,
      info1: [], // 通知公告,5
      info2: [], // 业务指南,7
      info3: [], // 常见问题,10
      info4: [], // 行业资讯,7
      info5: [], // 资料下载,6
      products: [], // 产品中心，6个块儿
    };
  },
  created() {
    this.getHomeListAll();
    this.products = [
      {
        title: "授信服务",
        detail:
          "通过金融机构，面向代理人提供优于市场的授信服务，为差旅代理人、批发类代理人提供资金支",
        url: icon06,
      },
      {
        title: "数据产品",
        detail:
          "包括航空运输市场数据分析，分析技术在航空业的应用将在多个方面有利于降低成本",
        url: icon07,
      },
      {
        title: "报表产品",
        detail:
          "报表形式主要为固定报表，同时为了满足航空公司的特殊需求，同样提供自定义报表",
        url: icon04,
      },
      {
        title: "培训产品",
        detail:
          "中国民航分销结算平台CDS宣贯培训，CDS操作培训，民航职业技能体系培训，航空业务培训",
        url: icon02,
      },
      {
        title: "金融服务",
        detail:
          "金融类产品，信用贷款和供应链融资服务，保险服务以及支付服务，金融杠杆类服务等。",
        url: icon01,
      },
      {
        title: "增值服务",
        detail:
          "在提供基本服务的基础上，通过不断细分用户和业务市场，满足更多的顾客期望",
        url: icon05,
      },
    ];
  },
  methods: {
    asyncTo(promise) {
      return promise.then((data) => [null, data]).catch((err) => [err]);
    },
    // 获取首页所有列表
    async getHomeListAll() {
      const titleList = [
        ["通知公告", 5],
        ["业务指南", 7],
        ["常见问题", 10],
        ["行业资讯", 7],
        ["资料下载", 6],
      ];
      for (const iterator of titleList.entries()) {
        const [error, {result:{list}}] = await this.asyncTo(
          this.$api.columnList({
            entity: {
              column: iterator[1][0],
              pageNum: this.pages.current,
              pageSize: this.pages.size,
            },
            pageNum: this.pages.current,
            pageSize: this.pages.size,
          })
        );
        if (error) {
          return;
        }
        this["info" + (iterator[0] + 1)] = Array.isArray(list)
          ? list.slice(0, iterator[1][1])
          : [];
      }
  
      // // 通知公告
      // const info1 = r.result.columnList["通知公告"];
      // this.info1 = Array.isArray(info1) ? info1.slice(0, 5) : [];
      // // 业务指南
      // const info2 = r.result.columnList["业务指南"];
      // this.info2 = Array.isArray(info2) ? info2.slice(0, 7) : [];
      // // 常见问题
      // const info3 = r.result.columnList["常见问题"];
      // this.info3 = Array.isArray(info3) ? info3.slice(0, 10) : [];
      // // 行业资讯
      // const info4 = r.result.columnList["行业资讯"];
      // this.info4 = Array.isArray(info4) ? info4.slice(0, 7) : [];
      // // 资料下载
      // const info5 = r.result.columnList["资料下载"];
      // this.info5 = Array.isArray(info5) ? info5.slice(0, 6) : [];
      // 给页脚传数据
      // this.$eventBus.$emit('set-footer', r.result.columnList)
      //});
    },
  
    async handleResourceInfo(item) {
      console.log(item,'-----')

      if (item.columnType == "1") {
        const [error ,{result} ]  = await this.asyncTo(this.$api.selectDescInfoById({id: item.id}))  
        if(error){
          return
        }
       const fileSplit =  result.content.match(/fileName=([\S\s]*\.(\S*))/)
        if (fileSplit[2] == "pdf") {
          this.showPDF(result.content, fileSplit[1]);
          return false
        } else {
          window.open(result.content);
        }
        return false;
        
      } else {
        return true;
      }
    },
    // 通知公告的文章详情页
    Tab1Details(item) {
      if (item.columnType == "1") {
        this.handleResourceInfo(item)
        return
      }
      
    
      this.$router.push({
        path: "/detail",
        query: { label: "通知公告", id: item.id },
      });
    },
    // 业务指南的文章详情页
    Tab2Details(item) {
      if (item.columnType == "1") {
        this.handleResourceInfo(item)
        return
      }
        
      this.$router.push({
        path: "/detail",
        query: { label: "业务指南", id: item.id },
      });
    },
    // 常见问题 的文章详情页
    Tab3Details(item) {
      if (item.columnType == "1") {
        this.handleResourceInfo(item)
        return
      }
      this.$router.push({
        path: "/detail",
        query: { label: "常见问题", id: item.id },
      });
    },
    // 行业资讯 的文章详情页
    Tab4Details(item) {
      if (item.columnType == "1") {
        this.handleResourceInfo(item)
        return
      }
      this.$router.push({
        path: "/detail",
        query: { label: "行业资讯", id: item.id },
      });
    },
    // 资料下载 的文章详情页
    downFile(item) {
      if (item.columnType == "1") {
        this.handleResourceInfo(item)
        return
      }
      this.$router.push({
        path: "/detail",
        query: { label: "资料下载", id: item.id },
      });
    },
    toTab(tab) {
      // label=行业资讯&tabid=1
      const m = {
        1: "行业资讯",
        2: "通知公告",
        3: "业务指南",
        4: "产品中心",
        5: "资料下载",
        6: "常见问题",
      };
      this.$router.push({
        path: "/article",
        query: { label: m[tab], productCenterType: "0" },
      });
    },
    //
    productCentertoTab(item) {
      console.log("in",item)
      // const name = this.secondMenuList.filter((item) => {
      //   return item.value == index + 1;
      // })[0].label;
      this.$router.push({
        path: "/article",
        query: { label: `产品中心 - ${item.title}`, productCenterType: item.index + 1 },
      });
    },
    //查看pdf
    showPDF(path, name) {
      console.log(path, name)
      let reg = /http:\/\/.*\.[0-9]{1,4}(:[\w]+)?/g

      path = path.replace(reg,process.env.VUE_APP_BASE)

      axios.get(path, { responseType: "blob" }).then(({ data }) => {
        console.log(data);
        let file = {};
        const blob = new Blob([data]);
        const url = window.URL.createObjectURL(blob);
        console.log(url);
        file.fileUrl = url;
        file.fileType = "pdf";
        file.name = name;
        this.$refs.showPDF.init(file);
      });
    },
    // 根据栏目id，获取列表
    // 拆分接口 解决一个接口获取页面全部数据,请求超时的问题
    getTabId(columnData) {
      const data = {
        entity: {
          column: columnData,
          pageNum: this.pages.current,
          pageSize: this.pages.size,
        },
        pageNum: this.pages.current,
        pageSize: this.pages.size,
      };
      this.$api.columnList(data).then((r) => {
        if (this.productCenterType > 0) {
          this.articles = r.result.list;
          this.articles = this.articles.filter((item) => {
            return item.productCenterType == this.productCenterType;
          });
        } else {
          this.articles = r.result.list;
          this.pages.total = r.result.total;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.home-container {
  // width: 1200px;
  margin: auto;
  img {
    width: 100%;
  }
  // 信息区域
  .infos {
    p {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    width: 1270px;
    margin: auto;
    display: flex;
    padding-top: 20px;
    // padding: 10px 20px 0;
    // height: 600px;
    // 信息区域 - 左侧
    .info-item {
      width: 0;
      flex-grow: 1;
      line-height: 1;
      .first-title {
        font-size: 20px;
        color: #222222;
        font-weight: bold;
        font-family: Microsoft YaHei;
        cursor: pointer;
        &::before {
          content: "";
          display: inline-block;
          width: 7px;
          border-radius: 2px;
          background: #01449b;
          height: 7px;
          vertical-align: middle;
          margin-right: 5px;
        }
      }
      // 小标题
      .first-title-small {
        margin-top: 16px;
        padding-left: 3px;
        font-size: 12px;
        color: #333333;
        // font-weight: bold;
        // line-height: 28px;
        font-family: Microsoft YaHei;
        cursor: pointer;
        &::before {
          content: "";
          display: inline-block;
          width: 3px;
          border-radius: 0px;
          background: #01449b;
          height: 3px;
          vertical-align: middle;
          margin-right: 5px;
        }
        // &:hover{
        //   background-color: #f7f7f7;
        // }
      }
      .first-msg {
        // max-height: 330px;
        color: #999999;
        font-size: 12px;
        // line-height: 20px;
        padding-left: 13px;
        margin: 22px 0 6px;
      }
      // 非首个信息区域的样式
      .other-item {
        height: 91px;
        padding: 21px 35px 19px 13px;
        box-sizing: border-box;
        background-color: #f7f7f7;
        border-radius: 3px;
        margin-top: 13px;
        overflow: hidden;
        .other-title {
          color: #222222;
          font-size: 14px;
          margin-bottom: 10px;
          cursor: pointer;
        }
        .other-msg {
          color: #999999;
          font-size: 12px;
          // line-height: 16px;
        }
      }
    }
    // 信息区域 - 中间
    // 信息区域，中间竖格的样式
    .info-item-center {
      margin: 0 20px;
      .info-item-harf-top {
        height: 250px;
        overflow: hidden;
      }
      .info-item-harf-bottom {
        margin-top: 50px;
        height: 329px;
      }
    }
    // 信息区域 - 右侧
    .info-item-left {
      margin: 0 20px;
      .info-item-harf-top {
        height: 250px;
        overflow: hidden;
      }
      // 资料下载
      .info-item-harf-bottom {
        margin-top: 50px;
        height: 329px;
        border: 1px #e0d7d7 solid;
        .head {
          padding-bottom: 35px;
          background-color: #f5f5f5;
          color: #333333;
          font-size: 16px;
          padding: 13px 0 11px 34px;
          border-bottom: 1px #e0d7d7 solid;
        }
        .down-list {
          padding: 12px 20px 20px;
          .list-item {
            padding: 12px 0;
            font-size: 12px;
            border-bottom: 1px dotted #e0d7d7;
            cursor: pointer;
            &::before {
              content: "";
              display: inline-block;
              width: 3px;
              border-radius: 0px;
              background: #e75619;
              height: 3px;
              vertical-align: middle;
              margin-right: 5px;
            }
          }
          p {
            display: block;
            font-size: 12px;
            color: #e75619;
            margin-top: 14px;
            text-align: right;
            cursor: pointer;
            &:hover {
              // transform: scale(1.2);
            }
          }
        }
      }
    }
  }
  // 产品中心
  .products {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    user-select: none;
    .pro-item {
      width: 408px;
      height: 297px;
      margin-bottom: 45px;
      box-shadow: 3px 2px 6px 1px #e0d7d7;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 40px 33px 0;
      box-sizing: border-box;

      & > img {
        width: 120px;
        height: 65px;
      }
      .title {
        font-size: 36px;
        font-weight: bolder;
        color: #fffefe;
        padding-top: 22px;
      }
      .detail {
        width: 100%;
        font-size: 16px;
        // font-weight: bolder;
        line-height: 28px;
        color: #fffefe;
        text-align: center;
        padding-top: 32px;
        word-wrap: break-word;
        overflow-wrap: break-word;
      }
    }
    // 配置各个产品块鼠标移动时的背景颜色
    div[pro-item-index="0"] {
      background-image: linear-gradient(to bottom, #5ab4ff, #2282d4);
      .detail {
        color: #add8fd !important;
      }
    }
    div[pro-item-index="1"] {
      background-image: linear-gradient(to bottom, #f18585, #e75a5a);
      .detail {
        color: #ffd4d4 !important;
      }
    }
    div[pro-item-index="2"] {
      background-image: linear-gradient(to bottom, #94e7a9, #44d669);
      .detail {
        color: #ebfff0 !important;
      }
    }
    div[pro-item-index="3"] {
      background-image: linear-gradient(to bottom, #28c9c6, #58e9e8);
      .detail {
        color: #98fbf9 !important;
      }
    }
    div[pro-item-index="4"] {
      background-image: linear-gradient(to bottom, #f9c679, #e3a750);
      .detail {
        color: #fedcab !important;
      }
    }
    div[pro-item-index="5"] {
      background-image: linear-gradient(to bottom, #b7d0ff, #737fef);
      .detail {
        color: #c8d3fe !important;
      }
    }
  }
}

// 本页公共样式
// p {
//   white-space: nowrap;
//   overflow: hidden;
//   text-overflow: ellipsis;
// }
</style>

<style lang="less">
// body{
//   line-height: 1;
// }
</style>
